import { useAppSelector } from "@sso/hooks/useRedux";
import { selectLicenceQuery } from "@sso/store/slices/licence";

import { useLicencesQuery } from "..";

export const useGetLicencesQuery = () => {
  const queryParams = useAppSelector(selectLicenceQuery);
  return useLicencesQuery(queryParams);
};
